module.exports = __webpack_public_path__ + "static/media/banner.b955b71f.avif";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fanuc/images/banner.avif
// module id = 589
// module chunks = 0